<template>
  <div class="accountsAndSecurity">
    <!--顶部导航-->
    <Navbar title="账户与安全" />
    <!--内容区域-->
    <div class="content" @click="handleClick()">
      <div class="setting-item">
        <div class="setting-item-content">
          <img src="@/assets/style/cancellation-icon.png" alt="" />
          <div class="setting-item-value">注销</div>
        </div>
        <div class="setting-item-icon">
          <img src="@/assets/style/oride-icon.png" alt="" />
        </div>
      </div>
    </div>
    <div class="logout">
      <div class="logout-content" @click="handleLogout">退出登录</div>
    </div>
    <Popup
      ref="unregisterPopup"
      message="确认操作后不可撤回，是否确认注销"
      confirmText="确认注销"
      cancelText="取消"
      @confirm="handleUnregister"
    />
    <Popup
      ref="logoutPopup"
      message="是否确认退出登录"
      confirmText="确认退出"
      cancelText="取消"
      @confirm="handleLogoutConfirm"
    />
    <Popup
      ref="popup1"
      message="当前存在未完结订单，请处理完成后在进行注销"
      confirmText="去查看"
      cancelText="取消"
      @confirm="gotoOrderList"
    />
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import { unregister, logout, getUnsettledOrderNum } from "@/api/index.js";
import Popup from "@/components/Popup/index.vue";

export default {
  name: "AccountsAndSecurity",
  components: {
    Navbar,
    Popup,
  },
  data() {
    return {};
  },
  async mounted() {},
  methods: {
    gotoOrderList() {
      this.$router.push({ name: "orderList" });
    },
    handleUnregister() {
      unregister().then((res) => {
        if (res.code === 2000) {
          localStorage.removeItem("actived");
          this.$toast("注销成功");

          if (process.env.VUE_APP_ENV === "productionApp") {
            //注销成功后，调用原生方法
            this.$JSBridge.send("serviceType", { type: "7" });
          } else {
            this.$router.push({ name: "Login" });
          }
        }
      });
    },
    handleLogoutConfirm() {
      //退出登录
      logout().then((res) => {
        if (res.code === 2000) {
          localStorage.removeItem("token");
          localStorage.removeItem("actived");
           this.$store.commit("setToken", "");
          this.$toast("退出登录成功");
          if (process.env.VUE_APP_ENV === "productionApp") {
            //注销成功后，调用原生方法
            this.$JSBridge.send("serviceType", { type: "6" });
          } else {
           setTimeout(() => {
            this.$router.push({ name: "Login" });
           }, 1000);
          }
        } else {
          this.$toast(res.msg || res.message || "退出登录失败");
        }
      });
    },
    async handleClick() {
      const res = await getUnsettledOrderNum();
      if (res.code == 2000) {
        if(res.data > 0){
          this.$refs.popup1.showPopup(); 
        }else{
          this.$refs.unregisterPopup.showPopup();
        }
      } else {
        this.$toast(res.msg || res.message);
      }
    },
    handleLogout() {
      this.$refs.logoutPopup.showPopup();
    },
  },
  computed: {
    preCheckData() {
      return this.$store.state.preCheckData;
    },
  },
};
</script>

<style scoped lang="scss">
.accountsAndSecurity {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f4f4f4;
  background-size: 100% 30%;
  background-repeat: no-repeat;
}
.content {
  padding: 20px 16px;
}
.setting-item {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  background: #fff;
  border-radius: 12px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
  align-items: center;
  font-size: 14px;
}
.setting-item-content {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
    margin-right: 10px;
  }
}
.setting-item-icon {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    height: 20px;
  }
}
.logout {
  position: fixed;
  bottom: 20px;
  left: 0;
  right: 0;
}
.logout-content {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  background: #1d70f7;
  border-radius: 30px;
  font-size: 18px;
  color: #fff;
  margin: 0px 16px;
}
</style>
